import React from 'react'

const EditorLayout = ({ children }) => {
    return (
        <div className="editor">
            <main>{children}</main>
        </div>
    )
}

export default EditorLayout
